<template>
   <v-dialog name="editRow" v-model="level.dialogValues.dialogShow" data-app="true" persistent max-width="900">
      <v-card>

         <CardUpdatableHeader :row="row" :level="level"/>

         <v-card-text>
            <v-container>
            <v-row>
               <v-col cols="12" sm="6">
                  <v-text-field v-model="row.prc_code" :disabled="level.dialogValues.form_disabled" outlined :label="$t('texts._required_code')" :rules="level.dialogOptions.codeRules" required :hint="$t('hints._code')" persistent-hint>
                  </v-text-field>
               </v-col>
               <v-col cols="12" sm="6">
                  <v-text-field v-model="row.prc_name" :disabled="level.dialogValues.form_disabled" :label="$t('texts.prc_name')" :hint="$t('hints.prc_name')"></v-text-field>
               </v-col>
            </v-row>
            <v-row>
               <v-col cols="12" sm="6">
                  <h4>{{ $t('subtitles.prc_margins') }}</h4>
               </v-col>
            </v-row>
            <v-row>
               <v-col v-if="!level.dialogValues.form_create" cols="12">
                  <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row.prc_create,'long') }}<br/>
                  <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row.prc_create,'long') }}
               </v-col>
            </v-row>
         </v-container>
            <small>*{{ $t('texts.requiredfield') }}</small>
         </v-card-text>

         <CardUpdatableFooter :row="row" :level="level"/>

      </v-card>
   </v-dialog>

</template>

<script>
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';

export default {
   name: 'CardUpdatableProductCategory',
   extends: CardUpdatable,
   components: {
      ddoAlert,
      CardUpdatableHeader,
      CardUpdatableFooter,
   },
   props: {
   },
   data: function () {
      return {
      }
   },

}
</script>